import { render, staticRenderFns } from "./StaticPageCreate.vue?vue&type=template&id=061034da"
import script from "./StaticPageCreate.vue?vue&type=script&lang=ts"
export * from "./StaticPageCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports